import { GAME_RULES } from '@ringmaster/shared';
import { suggestGameForCount, type GameFit } from '../assets/manifest.js';

/**
 * biggerShowFor — "this table has outgrown the game it is sitting in".
 *
 * The mirror image of the underfull nudge (`suggestGameForCount`, which answers
 * "you can't fill Blood Moon, but One Night fits right now"). Rooms are now BORN
 * `onenight` (2026-08-09), so a group that assembles five seats around the small
 * game is never told the flagship just became legal — and the analytics say the
 * drop-off sits exactly at Blood Moon's floor: of the rooms that peaked at 5,
 * only 3 of 7 ever played a Blood Moon game, against 14 of 15 at 6+.
 *
 * Derived, never hard-coded, exactly like its underfull sibling: the same
 * manifest suggestion (largest `minPlayers` that still fits the crowd, playable
 * tiles only) filtered down to games that are a step UP from the current one. A
 * table already on the biggest game its size allows gets nothing.
 */
export function biggerShowFor(currentGameId: string, playerCount: number): GameFit | null {
  const fit = suggestGameForCount(playerCount, currentGameId);
  if (!fit) return null;
  const currentMin = GAME_RULES[currentGameId]?.minPlayers ?? 0;
  // A sideways or downward suggestion is the underfull nudge's job, not this one.
  return fit.minPlayers > currentMin ? fit : null;
}
